import React, { useEffect, useState } from 'react'
import { Input, FormCustom } from '../../Components/Form/Form'
import Helpers from '../../Components/Helpers/Helpers';
import { toast } from 'react-toastify'

const ViaticosReembolso = ({ id_viaticos_doc, onSubmit, loadSubmit }) => {
    const [row, setRow] = useState({
        files: []
    });

    useEffect(() => {

    }, [])

    return <FormCustom onSubmit={_ => {
        let fd = new FormData();
        fd.append('p_id_viaticos_doc', id_viaticos_doc);
        fd.append('p_file', row.files[0]);

        onSubmit({
            data: fd
        });
    }} loadSubmit={loadSubmit}>
        <Input classNameParent="col-12 mb-3"
            text="Adjuntar Imagen"
            type="file"
            required
            onChange={e => setRow({
                ...row,
                files: e.currentTarget.files
            })}
            accept="image/*"
            invalid="Debe adjuntar una imagen"
        />
    </FormCustom>
}

ViaticosReembolso.defaultProps = {
    id_viaticos_doc: '',
    onSubmit: () => { },
    loadSubmit: false
}

export default ViaticosReembolso;